export const FETCH_CUSTOMER_LIST = "customer/FETCH_CUSTOMER_LIST";
export const FETCH_CUSTOMER_LIST_COMPLETED = "customer/FETCH_CUSTOMER_LIST_COMPLETED";
export const FETCH_CUSTOMER_LIST_FAILED = "customer/FETCH_CUSTOMER_LIST_FAILED";

export const UPDATE = "customer/UPDATE";
export const UPDATE_COMPLETED = "customer/UPDATE_COMPLETED";
export const UPDATE_FAILED = "customer/UPDATE_FAILED";